import React from 'react';

function ProfileEditor({ formData, handleChange, handleUpdate, handleArrayUpdate, saving, message }) {
  return (
    <div className="dashboard-settings glass-card animate-up">
      <h2 style={{borderBottom: '1px solid var(--glass-border)', paddingBottom: '15px', marginBottom: '25px'}}>Visual Dossier Enhancement</h2>
      {message && <div className="animate-up" style={{padding: '12px', background: 'rgba(0,255,140,0.1)', color: 'var(--brand-accent)', borderRadius: '12px', marginBottom: '20px', border: '1px solid var(--brand-accent)'}}>{message}</div>}
      
      <form onSubmit={handleUpdate}>
        <div className="form-grid" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '25px'}}>
          <div className="form-group">
            <label className="form-label">Neural Avatar URL</label>
            <input type="url" name="avatar" className="form-input" value={formData.avatar} onChange={handleChange} placeholder="https://example.com/photo.jpg" />
          </div>
          <div className="form-group">
            <label className="form-label">Verified Display Name</label>
            <input type="text" name="name" className="form-input" value={formData.name} onChange={handleChange} placeholder="First Last" />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Professional Logic Directive (Bio)</label>
          <input type="text" name="bio" className="form-input" value={formData.bio} onChange={handleChange} placeholder="Logic Architect | Full Stack" maxLength="100" />
        </div>

        <div className="form-row" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '25px'}}>
          <div className="form-group">
            <label className="form-label">Secure Contact</label>
            <input type="text" name="phone" className="form-input" value={formData.phone} onChange={handleChange} placeholder="+XX XXXXX XXXXX" />
          </div>
          <div className="form-group">
            <label className="form-label">LinkedIn Protocol</label>
            <input type="text" name="linkedin" className="form-input" value={formData.linkedin} onChange={handleChange} placeholder="https://linkedin.com/in/..." />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Executive Summary</label>
          <textarea name="summary" className="form-input" value={formData.summary} onChange={handleChange} placeholder="Describe your cognitive reach..." style={{minHeight: '120px'}}></textarea>
        </div>

        <div className="professional-dossier" style={{marginTop: '45px'}}>
          <h3 style={{marginBottom: '25px', color: 'var(--brand-accent)', fontSize: '1.3rem', fontWeight: '800'}}>Experience Nodes</h3>
          
          {formData.experience.map((exp, idx) => (
            <div key={idx} className="dossier-card glass-card" style={{padding: '20px', marginBottom: '20px', background: 'rgba(255,255,255,0.02)'}}>
              <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px'}}>
                <input className="form-input" placeholder="Organization" value={exp.company} onChange={e => handleArrayUpdate('experience', 'edit', idx, { company: e.target.value })} />
                <input className="form-input" placeholder="Designation" value={exp.role} onChange={e => handleArrayUpdate('experience', 'edit', idx, { role: e.target.value })} />
              </div>
              <input className="form-input" style={{marginBottom: '15px'}} placeholder="Temporal Duration (e.g. 2024 - Present)" value={exp.duration} onChange={e => handleArrayUpdate('experience', 'edit', idx, { duration: e.target.value })} />
              <textarea className="form-input" placeholder="Mission Objectives & Results" value={exp.desc} onChange={e => handleArrayUpdate('experience', 'edit', idx, { desc: e.target.value })} style={{minHeight: '100px'}} />
              <button type="button" onClick={() => handleArrayUpdate('experience', 'remove', idx)} style={{color: '#ff3b30', background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.8rem', marginTop: '15px', fontWeight: 'bold'}}>Terminate Node</button>
            </div>
          ))}
          <button type="button" onClick={() => handleArrayUpdate('experience', 'add', 0, { company: '', role: '', duration: '', desc: '' })} className="btn btn-secondary" style={{width: '100%', marginBottom: '30px'}}>+ Initialize New Experience Node</button>
        </div>

        <div className="achievements-section" style={{marginTop: '45px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px'}}>
            <h3 style={{margin: 0, color: 'var(--brand-accent)', fontSize: '1.3rem', fontWeight: '800'}}><i className="fa-solid fa-award"></i> Neural Achievements</h3>
            <button type="button" onClick={() => handleArrayUpdate('achievements', 'add', null, "New Achievement entry...")} className="btn-mini" style={{background: 'rgba(0, 255, 174, 0.1)', border: '1px solid var(--brand-accent)', color: 'var(--brand-accent)', padding: '5px 12px', borderRadius: '8px', cursor: 'pointer', fontSize: '0.8rem'}}><i className="fa-solid fa-plus"></i> Add Milestone</button>
          </div>
          {(formData.achievements || []).map((award, index) => (
            <div key={index} className="dossier-item glass-card" style={{display: 'flex', gap: '15px', marginBottom: '15px', padding: '15px', background: 'rgba(255,255,255,0.02)'}}>
              <input 
                type="text" 
                className="form-input" 
                value={award} 
                onChange={(e) => {
                  const newList = [...formData.achievements];
                  newList[index] = e.target.value;
                  // Note: This needs to trigger the parent's handleChange or a custom one.
                  // Since we passed formData and it's local to the parent Dashboard,
                  // we should ideally use a handler. 
                  // But ProfileEditor uses handleArrayUpdate for lists.
                  // I'll assume handleArrayUpdate supports 'edit' for achievements too.
                  handleArrayUpdate('achievements', 'edit', index, e.target.value);
                }}
                style={{flex: 1}}
              />
              <button type="button" onClick={() => handleArrayUpdate('achievements', 'remove', index)} style={{background: 'none', border: 'none', color: '#ff3b30', cursor: 'pointer'}}><i className="fa-solid fa-trash"></i></button>
            </div>
          ))}
        </div>

        <div className="platform-integrations" style={{marginTop: '40px'}}>
           <h3 style={{marginBottom: '20px', color: 'var(--text-secondary)', fontSize: '1.1rem'}}>Neural Handshakes (Integrations)</h3>
           <div className="form-grid" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px'}}>
              <div className="form-group">
                <label className="form-label"><i className="fa-brands fa-github"></i> GitHub Matrix</label>
                <input type="text" name="githubUsername" className="form-input" value={formData.githubUsername} onChange={handleChange} placeholder="Username" />
              </div>
              <div className="form-group">
                <label className="form-label"><i className="fa-solid fa-code"></i> LeetCode Sync</label>
                <input type="text" name="leetcodeUsername" className="form-input" value={formData.leetcodeUsername} onChange={handleChange} placeholder="Username" />
              </div>
              <div className="form-group">
                <label className="form-label"><i className="fa-solid fa-ghost"></i> Codeforces Sync</label>
                <input type="text" name="codeforcesUsername" className="form-input" value={formData.codeforcesUsername} onChange={handleChange} placeholder="Username" />
              </div>
              <div className="form-group">
                <label className="form-label"><i className="fa-solid fa-graduation-cap"></i> GFG Matrix</label>
                <input type="text" name="gfgUsername" className="form-input" value={formData.gfgUsername} onChange={handleChange} placeholder="Username" />
              </div>
           </div>
        </div>

        <button type="submit" className="btn btn-primary" style={{width: '100%', marginTop: '30px', height: '55px', fontSize: '1.1rem'}} disabled={saving}>
          {saving ? 'Synchronizing...' : 'Commit Changes to Core'}
        </button>
      </form>
    </div>
  );
}

export default ProfileEditor;
